export default "/static/media/404.74cfff51.webm";